import type { Cards, TaskList } from '../../../../common/types.tsx';
import { CREATE_ISSUE_TASK } from '../../../../common/constants.tsx';
import { messages } from './messages.tsx';

export const PLAN_TASK_LIST: TaskList = Object.freeze({
	root: {
		title: messages.rootTitle,
		// TODO: JPO-35036 Replace items with plan task items
		items: [CREATE_ISSUE_TASK],
	},
});

export const PLAN_TASK_VARIANTS: Cards = {
	[CREATE_ISSUE_TASK]: {
		position: { default: 0 },
		visibility: {
			default: true,
		},
	},
};
